const GetOrderStyle = (status,type='label') => {

    let label;
    let heading;
    let color;
    let bgColor;

    switch (status) {
        case 'pending-approval-exceeded-limit':
            label = 'بإنتظار التأكيد';
            heading = 'طلب قيد التأكيد';
            color = 'text-pandingOps';
            bgColor = 'bg-pandingOps';
            break;
        case 'pendingMerchant':
            label = 'بإنتظار التاجر';
            heading = 'بإنتظار التاجر';
            color = 'text-orange';
            bgColor = 'bg-orange';
            break;
        case 'merchantAccepted':
            label = 'تحت العمل';
            heading = 'الطلب تحت العمل';
            color = 'text-blue';
            bgColor = 'bg-blue';
            break;
        case 'deliveryAssigned':
            label = 'جاهز للتوصيل';
            heading = 'الطلب جاهز للتوصيل';
            color = 'text-blue';
            bgColor = 'bg-blue';
            break;
        case 'deliveryOnWayToCustomer':
            label = 'في الطريق الي العميل';
            heading = 'الطلب في الطريق الي العميل';
            color = 'text-blue';
            bgColor = 'bg-blue';
            break;
        case 'delivered':
            label = 'تم التوصيل';
            heading = 'تم توصيل الطلب';
            color = 'text-success';
            bgColor = 'bg-success';
            break;
        case 'active':
            label = 'تحت العمل';
            heading = 'الطلب تحت العمل';
            color = 'text-blue';
            bgColor = 'bg-blue';
            break;
        case 'canceled':
            label = 'ملغاة';
            heading = 'الطلب ملغي';
            color = 'text-danger';
            bgColor = 'bg-danger';
            break;
        case 'rejected':
            label = 'مرفوض';
            heading = 'الطلب مرفوض';
            color = 'text-danger';
            bgColor = 'bg-danger';
            break;
        case 'pending':
            label = 'تم إرسال الطلب';
            heading = 'جاري تحضير الطلب';
            color = 'text-orange';
            bgColor = 'bg-orange';
            break;
        case 'timedOut':
            label = 'ملغي لانتهاء الوقت';
            heading = 'الطلب ملغي لانتهاء الوقت';
            color = 'text-danger';
            bgColor = 'bg-danger';
    }

    if(type === 'label') {
        return label;
    } else if (type === 'heading') {
        return heading;
    } else if (type === 'bg') {
        return bgColor;
    } else if (type === 'color') {
        return color;
    }


}

export default GetOrderStyle;